import React from 'react';
import { useParams } from 'react-router-dom';

const ViewForm = () => {
    const { formId } = useParams();

    return (
        <div style={iframeWrapper}>
            <iframe
                src={`/admin/print/${formId}`}
                title="Form Preview"
                style={iframeStyle}
            />
        </div>
    );
};

export default ViewForm;

/* ---------- styles ---------- */

const iframeWrapper = {
    width: '100%',
    height: '100vh',
    background: '#eee'
};

const iframeStyle = {
    width: '100%',
    height: '100%',
    border: 'none'
};
